import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invoicing-menu-component',
  templateUrl: './menu.component.html'
})
export class InvoicingMenuComponent implements OnInit {

  role = "";
  adminmenuOptions = [
    {title: "Invoicing" ,subItems: [{name: 'Carriers', path: '/invoicing/carrier',icon:'home'}, {name: 'Customer Invoices', path: '/invoicing/customer-invoice'}]},
    {title: "Administration" ,subItems: [{name: 'Carriers', path: '/administration/carrier',icon:'home'}, {name: 'Carriers', path: '/administration/client'},{name: 'Create User', path: '/administration/User',icon:'home'}]},
  ]
  usermenuOptions = [
    {title: "Invoicing" ,subItems: [{name: 'Carriers', path: '/invoicing/carrier',icon:'home'}, {name: 'Customer Invoices', path: '/invoicing/customer-invoice'}]},
  ]

  ngOnInit(): void {
    this.role = localStorage.getItem('Role');
  }


  // <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/administration/carrier"]'>Carriers</a>
  // <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/administration/client"]'>Clients</a>
  // <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/administration/User"]'>Create User</a>
//  constructor(route: ActivatedRoute) {

//    route.params.subscribe(params => console.log("side menu id parameter", params['id']));

//  }
}
